import React, { useEffect } from "react";
import { Wrapper } from "./Wrapper";
import { ProductThumb } from "./ProductThumb";
import { MediumSubTitle } from "../typography";
import { Row, Spacing, Column } from "../helpers/layout";
import { addToRecentlyViewed } from "../actions/addToRecentlyViewed";
import { css } from "styled-components";
import { useRecentlyViewed } from "../context/RecentlyViewedContext";
import { Scrollbar } from "./Scrollbar";
import { getProductSize } from "../helpers/product";

export function RecentlyViewed(props: { productId: number }) {
  const { recentlyViewed, fetchRecentlyViewed } = useRecentlyViewed();

  useEffect(() => {
    async function markAsViewed() {
      try {
        await addToRecentlyViewed(recentlyViewed.uuid, {
          product: props.productId
        });

        await fetchRecentlyViewed();
      } catch (e) {
        console.log(e);
      }
    }
    if (recentlyViewed.uuid) {
      markAsViewed();
    }
  }, [recentlyViewed.uuid]);

  if (recentlyViewed.items.length) return <div css={css`padding-top: ${Spacing.xxl}`} />;

  return (
    <div
      css={css`
        padding: ${Spacing.xxl} 0;
        text-align: center;
      `}
    >
      <Wrapper>
        <Column gutter={Spacing.xxl}>
          <MediumSubTitle>Recently viewed</MediumSubTitle>
          <Scrollbar autoHeight>
            <Row>
              {recentlyViewed.items.map(item => {
                const { product } = item;
                const size = getProductSize(product);

                return (
                  <div
                    key={`recently-viewed--${product.id}`}
                    css={css`
                      flex: 0 0
                        ${size
                          ? `${(240 * size.width) / size.height}px}`
                          : "auto"};

                      img {
                        height: 230px;
                        max-width: none;
                        width: auto;
                      }
                    `}
                  >
                    <ProductThumb
                      product={product}
                      key={`recenty-viewed--${product.id}`}
                      align="center"
                    />
                  </div>
                );
              })}
            </Row>
          </Scrollbar>
        </Column>
      </Wrapper>
    </div>
  );
}
